import { useState, useEffect } from 'react';

export default (url: string) => {
  const [videoDuration, setVideoDuration] = useState(0);

  useEffect(() => {
    if (!url) return;

    const video = document.createElement('video');
    video.addEventListener('loadedmetadata', e => {
      const { duration } = e.target as HTMLVideoElement;
      setVideoDuration(duration);
    });
    video.src = url;
  }, [url]);

  return videoDuration;
};
